module.exports = __webpack_public_path__ + "img/Household-Ergo-Books-and-Boxes.ee4959cf.png";